import { useTranslation } from '@web_opxp/features';
import React, { useMemo } from 'react';
import { getExerciseIconSrc } from '../../assets';
import ENV from '../../base/env';
import './CelebrationBadge.scss';

export interface ICelebrationBadgeProps {
  exerciseId: string;
  score: number;
}

export const CelebrationBadge: React.FC<ICelebrationBadgeProps> = ({ exerciseId, score }) => {
  const { t } = useTranslation();

  const iconSrc = useMemo(() => getExerciseIconSrc(exerciseId), [exerciseId]);
  const ribbonLabel = useMemo(() => t('Achievements.Celebration.Score', { score }), [score, t]);
  return (
    <div className="achievements-badge">
      <div className="badge-container">
        <img
          className="badge-bg"
          src={`${ENV.AssetsBaseUrl}/feature/achievements/AchievementsBadge.png`}
          alt="Celebration badge"
        />
        <img className="badge-exercise-icon" src={iconSrc} alt={exerciseId} />
      </div>
      <div className="ribbon-container">
        <img className="ribbon-bg" src={`${ENV.AssetsBaseUrl}/feature/achievements/Ribbon.png`} alt={ribbonLabel} />
        <span className="ribbon-scores">{ribbonLabel}</span>
      </div>
    </div>
  );
};

export default CelebrationBadge;
